import { create } from 'zustand'
import { produce } from 'immer'
import _ from 'lodash'

export const useHubAssinatura = create((set) => ({
  data: {
    details: {},
  },
  actions: {
    setDetails: (data) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.details = data
        }),
      ),
  },
}))
